export default {
  header: 'Ups, coś poszło nie tak',
  text: 'Uruchom ponownie stronę lub kliknij przycisk „Powrót do menu" poniżej.',
  button: 'Powrót do menu',
};
